import jsPDF from 'jspdf';
import ff from './ff';
import QRCode from 'qrcode';

/*
20211118 rht を n_pdd に対応させる
20211118 o_drawRgl において backCcd を指定可能とする
 */

export default class myPD {

static _n_rto = 2.4;
static _n_fontSizeNrm = 10;
static _n_mgnTop = myPD._n_fontSizeNrm;
static _n_mgnLeft = 18;
static _n_lineH = myPD._n_fontSizeNrm * 1.6;
static _n_maxCmn = 54; // landscape : 77
static _n_maxRow = null; // landscape : 34
static _n_pdd = myPD._n_fontSizeNrm * 0.5;

static _o_clrCvs (
  po_cvs,
  po_ctx,
) {
  po_ctx.clearRect(0, 0, po_cvs.width, po_cvs.height);
  po_ctx.fillStyle = '#ffffff';
  po_ctx.fillRect(0, 0, po_cvs.height, po_cvs.height);
};

static _op_pstCvsToPdf = ( // paste canvas to pdf
  po_cvs,
  po_pdf,
) => new Promise( async _o_end1 => {
  let _img = await po_cvs.toDataURL('image/png', 1.0)
//  await po_pdf.addImage(_img, 'PNG', myPD._n_mgnLeft, myPD._n_mgnTop, po_cvs.width / myPD.n_rto, po_cvs.height / myPD.n_rto, undefined, 'FAST')
  await po_pdf.addImage(_img, 'PNG', myPD._n_mgnLeft, myPD._n_mgnTop, po_cvs.width / myPD._n_rto, po_cvs.height / myPD._n_rto, undefined, 'FAST')
  _o_end1();
});

static _op_addNewPageToPdf = (
  po_pdf
) => new Promise( async _o_end1 => {
  await po_pdf.addPage();
  _o_end1();
})

static _op_savePdf = (
  po_pdf,
  p_file,
) => new Promise( async _o_end1 => {
  await po_pdf.save(p_file)
  _o_end1();
});

static _o_drawText = (pd={
  o_ctx: null,
  pfx: '',
  n_x: 0,
  n_y: 0,
  n_w: 0,
  n_h: 0,
  n_cmn: 0,
  n_row: 0,
  n_cmnCnt: 0,
  n_rowCnt: 0,
  n_size: 0,
  n_lineW: 1,
  ccd: '',
  backCcd: null,
  b_bold: '',
}) => {

  let _n_lineW = pd.n_lineW ?? 1;

  let _n_x1 = (pd.n_cmn || pd.n_cmn == 0) ? myPD._o_cmnToX(pd.n_cmn) : pd.n_x;
  let _n_w = (pd.n_cmnCnt || pd.n_cmnCnt == 0) ? myPD._o_cmnToX(pd.n_cmnCnt) : pd.n_w;
  let _n_x2 = _n_x1 + _n_w;
  let _n_y1 = (pd.n_row || pd.n_row == 0) ? myPD._o_rowToY(pd.n_row) : pd.n_y;
  let _n_h = (pd.n_rowCnt || pd.n_rowCnt == 0) ? myPD._o_rowToY(pd.n_rowCnt) : pd.n_h;
  let _n_y2 = _n_y1 + _n_h;

  if (pd.b_frm) {
    myPD._o_drawRgl({
      o_ctx: pd.o_ctx, 
      n_x: _n_x1, 
      n_y: _n_y1, 
      n_w: _n_w, 
      n_h: _n_h, 
      n_lineW: _n_lineW,
      backCcd: pd.backCcd ?? null,
    });
  }

  pd.o_ctx.font = '{} {}pt -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'.f(
    (pd.b_bold) ? 'bold' : '',
    (pd.n_size ?? 1 ) * myPD._n_fontSizeNrm,
  );

/*
  let _d_msrs = myPD._o_msrText(pd.o_ctx, pd.pfx) // font size に影響があるものは msrText 前に実行
  let _n_adjX = 
    (pd.aln == 'left') ? 
      myPD._n_pdd
    : (pd.aln == 'ctr') ? 
      ( _n_w - _d_msrs.n_w ) / 2
    : (pd.aln == 'rht') ? 
      ( _n_w - _d_msrs.n_w - myPD._n_pdd)
    : 0;
  let _n_adjY = ( _n_h - _d_msrs.n_h ) / 2;
*/

  if (ff.f(pd.pfx)) {
    pd.o_ctx.fillStyle = pd.ccd ?? 'black';
    const _l = [];
    let _s = '';
    for ( let _i = 0; _i < ff.myCM_getLen(pd.pfx); _i++) {
      const _d_msrs = myPD._o_msrText(pd.o_ctx, _s + pd.pfx.charAt(_i))
      if ( (_d_msrs.n_w + 10) >= myPD._o_cmnToX(pd.n_cmnCnt) ) {
        _l.push(_s);
        _s = '';
      }
      _s += pd.pfx.charAt(_i);
    };
    if ( ff.f(_s) ) _l.push(_s);
    const _n_cnt = ff.myCM_getLen(_l);
/*
    pd.o_ctx.fillText(
//      pd.pfx ?? '', 
      _pfx ?? '', 
      _n_x1 + _n_adjX,
      _n_y1 + _n_h - _n_adjY,  
    );
*/

    const _b_mln = _n_cnt <= 1 ? false : (pd.b_mln ?? false);
    let _n_rowH = myPD._o_msrText(pd.o_ctx, 'あ').n_h;
    let _n_adjY = 
      (_b_mln) ? 
        ( _n_h - myPD._o_rowToY(_n_cnt) ) / 2
      :
        ( _n_h - _n_rowH * _n_cnt ) / 2;

    _l.map( (_pfx, _idx) => {
//ff.l('myPD 144: {}, {}, {}'.f(_idx, _pfx, _b_mln));

      let _d_msrs = myPD._o_msrText(pd.o_ctx, _pfx) // font size に影響があるものは msrText 前に実行
      let _n_adjX = 
        (pd.aln == 'left') ? 
          myPD._n_pdd
        : (pd.aln == 'ctr') ? 
          ( _n_w - _d_msrs.n_w ) / 2
        : (pd.aln == 'rht') ? 
          ( _n_w - _d_msrs.n_w - myPD._n_pdd)
        : 0;
      
      const _n_y = 
        (_b_mln) ? 
          ( _n_y1 + myPD._o_rowToY(_idx + 1) + _n_adjY ) 
        : ( _n_y1 + _n_rowH + _n_adjY );
ff.l('myPD 160: {}, {}, {}, {}, {}, {}'.f(_idx, _pfx, pd.b_mln, _n_cnt, _b_mln, _n_y));

      pd.o_ctx.fillText(
        _pfx ?? '', 
        (pd.b_mln) ? (_n_x1 + 5) : (_n_x1 + _n_adjX),
        _n_y
      );
    } );
  };
};

static _o_drawLine = (pd={
  o_ctx: null,
  n_x1: 0,
  n_y1: 0,
  n_x2: 0,
  n_y2: 0,
  ccd: '',
  n_lineW: 1,
}) =>{
ff.l('333: {}'.f(pd))
  pd.o_ctx.beginPath();
  pd.o_ctx.moveTo( pd.n_x1, pd.n_y1);
  pd.o_ctx.lineTo( pd.n_x2, pd.n_y2);
  pd.o_ctx.strokeStyle = pd.ccd ?? 'black';
  pd.o_ctx.lineWidth = pd.n_lineW ?? 0.5;
  pd.o_ctx.stroke();
};

static _o_drawRgl = (pd={ // rectangle
  o_ctx: null,
  n_x: null,
  n_y: null,
  n_w: null,
  n_h: null,
  n_lineW: 1,
  backCcd: null,
}) => {
  pd.o_ctx.lineWidth = pd.n_lineW ?? 1;
  if (pd.backCcd) { // 背景色あり
    pd.o_ctx.fillStyle = pd.backCcd;
    pd.o_ctx.fillRect(pd.n_x, pd.n_y, pd.n_w, pd.n_h)
    pd.o_ctx.strokeStyle = pd.ccd ?? 'black';
    pd.o_ctx.strokeRect(pd.n_x, pd.n_y, pd.n_w, pd.n_h)
  }
  else { // 背景色なし
    pd.o_ctx.strokeStyle = pd.ccd ?? 'black';
    pd.o_ctx.strokeRect(pd.n_x, pd.n_y, pd.n_w, pd.n_h)
  }
}

static _o_drawImg = (pd={
  o_ctx: null,
  url: null,
  n_x: null,
  n_y: null,
  n_row: null,
}) => new Promise( _o_end1 => {
  let _img = new Image();
  _img.src = pd.url;
  _img.crossOrigin = "anonymous"; 
  let _n_x = ((pd.n_cmn) ? myPD._o_cmnToX(pd.n_cmn) : pd.n_x) + myPD._n_mgnLeft;
  let _n_y = ((pd.n_row) ? myPD._o_rowToY(pd.n_row) : pd.n_y) + myPD._n_mgnTop;
  let _n_w = myPD._n_fontSizeNrm * myPD._n_maxCmn;
  _img.onload = async () => {
    pd.o_ctx.drawImage(_img, _n_x, _n_y, _n_w, _n_w * _img.height / _img.width );
    _o_end1();
  };
});

static _o_drawQr = (pd={
  o_ctx: null,
  url: null,
  n_x: null,
  n_y: null,
  n_row: null,
}) => new Promise( _o_end1 => {
  // https://dev.to/scotchbright/jspdf-qr-code-tutorial-code-samples-how-to-generate-a-pdf-with-a-qrcode-using-the-jspdf-qrcode-js-library-2hld
  // https://www.fixes.pub/program/701584.html
  // https://stackoverflow.com/questions/23861986/create-qrcode-with-output-base64-from-javascript/34542431
  // https://blog.katsubemakito.net/nodejs/qrcode-generates
/*
  let _o_div = document.createElement('div');
  _o_div.id = 'qr_code'
  let _qrcode = new QRCode('qr_code', {
      text: "https://cravecookie.com/",
      width: 128,
      height: 128,
      colorDark : "#000000",
      colorLight : "#ffffff",
      correctLevel : QRCode.CorrectLevel.H
  });
  let _imgBase64Data = _qrcode._oDrawing._elCanvas.toDataURL("image/png")
*/
/*
  let _qr = QRCode(4, 'M');
  _qr.addData('Thi is base64 string');
  _qr.make();
  let _imgBase64Data = 'data:image/gif;base64,' + _qr.createImgTag();
*/
//  QRCode.toDataURL('Hello QR', (_err, _base64) => {
  QRCode.toDataURL(pd.pfx, (_err, _base64) => {
    let _n_x = ((pd.n_cmn) ? myPD._o_cmnToX(pd.n_cmn) : pd.n_x) + myPD._n_mgnLeft;
    let _n_y = ((pd.n_row) ? myPD._o_rowToY(pd.n_row) : pd.n_y) + myPD._n_mgnTop;
//    let _n_w = myPD._n_fontSizeNrm * myPD._n_maxCmn;
    let _n_w = myPD._n_fontSizeNrm * 8;
    let _img = new Image();
    _img.src = _base64;
    _img.onload = async () => {
//      pd.o_ctx.drawImage(_img, _n_x, _n_y, _n_w, _n_w * _img.height / _img.width );
      pd.o_ctx.drawImage(_img, _n_x, _n_y, _n_w, _n_w * _img.height / _img.width);
      _o_end1();
    };
  });
})

static _o_cmnToX = pn_cmn => pn_cmn * myPD._n_fontSizeNrm;

static _o_rowToY = pn_row => myPD._n_lineH * pn_row;

static _o_msrText = (po_ctx, p_text) => { 
/*
measureText will use the currently set font property, and is also relative to the current context's transform
https://stackoverflow.com/questions/60954558/canvas-context-measuretext-not-working-properly
*/
  let _d_msrs = po_ctx.measureText(p_text);
  return { 
    n_w: _d_msrs.width,
    n_h: myPD._n_fontSizeNrm,
  };
};

static myPD_dwlFile = (pd={
  file: '',
  ld_iss: [],
  d_inis: {},
}) => new Promise( async _o_end1 => { // only for web

  let _d_inis = {
    orientation: 'landscape', // portrait
    unit: 'pt',
    format: 'a4',
    compress: true,
    ...pd.d_inis
  };
  let _o_pdf = new jsPDF(_d_inis);

  let _o_cvs = document.createElement('canvas');
  _o_cvs.width = 297 * 4 * myPD._n_rto;
  _o_cvs.height = _o_cvs.width / 297.0 * 210.0; // a4 l 400dpi

  let _o_ctx = _o_cvs.getContext('2d');
  _o_ctx.scale(myPD._n_rto, myPD._n_rto);

  myPD._o_clrCvs(_o_cvs, _o_ctx);

  for await (let [_idx, _d_is] of ff.e(pd.ld_iss)) {

    if (_d_is.type == 'line') {
      myPD._o_drawLine(ff.c(_d_is, {
        o_ctx: _o_ctx,
      }));
      continue;
    };

    if (_d_is.type == 'text') {
/*
      myPD._o_drawText({
        o_ctx: _o_ctx,
        n_rowCnt: 1,
        ..._d_is,
        pfx: ' ', // 初回表示のレイアウト崩れを防ぐ
      });
*/
//ff.l('myPD 334: {}'.f(_d_is))
      myPD._o_drawText({
        o_ctx: _o_ctx,
        n_rowCnt: 1,
        ..._d_is
      });
      continue;
    }

    if (_d_is.type == 'img') {
      await myPD._o_drawImg({
        o_ctx: _o_ctx,
        n_x: 0,
        ..._d_is
      });
      continue;
    };

    if (_d_is.type == 'qr') {
      await myPD._o_drawQr({
        o_ctx: _o_ctx,
        n_x: 0,
        ..._d_is
      });
      continue;
    };

    if (_d_is.type == 'clrCvs') {
      myPD._o_clrCvs(_o_cvs, _o_ctx);
      continue;
    };

    if (_d_is.type == 'pstCvsToPdf') {
      await myPD._op_pstCvsToPdf(_o_cvs, _o_pdf);
      continue;
    };

    if (_d_is.type == 'addNewPageToPdf') {
      await myPD._op_addNewPageToPdf(_o_pdf)
      continue;
    };

    if (_d_is.type == 'savePdf') {
      await myPD._op_savePdf(_o_pdf, pd.file);
      continue;
    }

    ff.l('incorrect type at myPD_dwlFile {}'.f(_d_is.type))
  }
  _o_end1();

});

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
